import styled from "styled-components";
import SubTitle from "./SubTitle";
import historyBackgroundImage from "../assets/images/history-bg.jpg";

const HistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  animation: zoomIn 1.5s forwards;

  @keyframes zoomIn {
    from {
      transform: scale(0.9);
    }
    to {
      transform: scale(1);
    }
}
`;

const HistoryBackgroundWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const HistoryBackgroundImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
`;

const HistoryContent = styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  animation: zoomIn 2s forwards;
  font-size: 18px;
  color: #000;
`;

const YearContainer = styled.ul`
  position: absolute;
  top: 13%;
  left: calc(50% + 3px);
  transform: translateX(-50%);
  width: 100%;
  height: 100%;
`;

const YearItem = styled.li`
  position: absolute;
  font-size: 3.6rem;
  font-weight: 800;
  color: #fff;
  left: 50%;
  transform: translateX(-50%);

  &:first-child {
    top: 0;
  }

  &:last-child {
    top: 37%;
  }
`;

const HistoryTextRightItemWrapper = styled.div`
  width: 100%;
  margin-top: 37%;
  font-size: 1.8rem;
  font-weight: 700; 
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  padding-left: 52.5%;

  >span {
    color: var(--primary-c-hover);
    font-size: 32px;
    font-weight: 700;
    transition: all 0.3s ease-in;
  }
`;

const HistoryRightTextItem = styled.div`
  width: 100%;
  transition: all 0.3s ease-in;
`;

const HistoryTextLeftContent = styled.div`
  width: 100%;
  margin-top: 31.5%;
  font-size: 1.8rem;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  max-height: 215px;
  word-break: keep-all;
  transition: all 0.3s ease-in;

  @media (max-width: 1080px) {
    max-height: 200px;
  }

  @media (max-width: 980px) {
    max-height: 175px;
  }

  @media (max-width: 880px) {
    margin-top: 30%;
    max-height: 160px;
  }

  @media (max-width: 800px) {
    margin-top: 30%;
    max-height: 155px;
  }
`;

const HistoryTextLeftItemWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;

  >span {
    padding-right: 51.5%;
    color: var(--primary-c);
    font-size: 3.2rem;
    font-weight: 700;
    transition: all 0.3s ease-in;
  }
`;

const HistoryLeftTextItem = styled.div`
  width: 100%;
  text-align: right;
  transition: all 0.3s ease-in;
`;

export default function History() {

  return (
    <HistoryContainer>
      <SubTitle title="연혁" />
      <HistoryBackgroundWrapper>
        <HistoryBackgroundImage src={historyBackgroundImage} alt="연혁 배경" />
        <HistoryContent>
          <YearContainer>
            <YearItem>2003</YearItem>
            <YearItem>2019</YearItem>
          </YearContainer>
          <HistoryTextRightItemWrapper>
            <span>03</span><HistoryRightTextItem>설립</HistoryRightTextItem>
          </HistoryTextRightItemWrapper>
          <HistoryTextLeftContent>
            <HistoryTextLeftItemWrapper>
              <HistoryLeftTextItem>광교회계법인의 일부 사업부를 합병</HistoryLeftTextItem><span>03</span>
            </HistoryTextLeftItemWrapper>
            <HistoryTextLeftItemWrapper>
              <HistoryLeftTextItem>길인회계법인의 일부 사업부를 합병(광주분사무소)</HistoryLeftTextItem><span>06</span>
            </HistoryTextLeftItemWrapper>
            <HistoryTextLeftItemWrapper>
              <HistoryLeftTextItem>전담 품질관리실과 품질관리위원회 설치</HistoryLeftTextItem><span>11</span>
            </HistoryTextLeftItemWrapper>
          </HistoryTextLeftContent>
        </HistoryContent>
      </HistoryBackgroundWrapper>
    </HistoryContainer>
  );
}